/**
 * Alias les tags Hector hallucinés vers leur équivalent canonique.
 *
 * Politique attrs : strip systématique des attributs présents sur le tag
 * halluciné. L'alias détermine seul les attrs canoniques (type est implicite
 * dans le mapping).
 *
 * Politique closing-only : un closing tag halluciné SANS opening matching
 * est DROPPÉ (chaîne vide). Sinon on créerait un </hector-callout> orphelin
 * qui n'est consommé par aucun parseur balanced en aval — exactement le bug
 * Codex a remonté sur la séquence COM UNIC :
 *   <hector-callout type= "warning">…</hector-callout> </hector-info>
 *
 * Mécanisme : scan séquentiel, stack des aliases ouverts. Closing matché
 * (LIFO) → conversion. Closing orphelin → strip.
 *
 * Garantit l'idempotence : sortie canonique ou supprimée, jamais re-matchable.
 */
const ALIAS_TO_CALLOUT_TYPE: Record<string, string> = {
  'hector-info': 'info',
  'hector-warning': 'warning',
  'hector-success': 'success',
  'hector-note': 'info',
};

const TAG_RE = /<(\/?)hector-(info|warning|success|note)(?:\s+[^>]*?)?(\s*\/?)>/g;

export function hallucinatedAlias(text: string): string {
  if (!text) return text;

  const aliasStack: string[] = [];

  return text.replace(TAG_RE, (_match, slash: string, suffix: string, selfClose: string) => {
    const tag = `hector-${suffix}`;
    const calloutType = ALIAS_TO_CALLOUT_TYPE[tag] ?? 'info';

    if (slash === '/') {
      // Closing tag : drop si orphelin (pas d'opening matching dans le stack)
      const idx = aliasStack.lastIndexOf(tag);
      if (idx === -1) {
        return '';
      }
      aliasStack.splice(idx, 1);
      return '</hector-callout>';
    }

    // Opening tag — vérifier self-close
    if (selfClose.includes('/')) {
      // Self-closing : conversion directe, pas de stack
      return `<hector-callout type="${calloutType}" />`;
    }

    aliasStack.push(tag);
    return `<hector-callout type="${calloutType}">`;
  });
}
